import userService from "../services/userService";

export const validPassword = (password) => {
	// Between 8 ad 50 chars
	// At least 1 uppercase char
	// At least 1 lowercase char
	// At least 1 special char
	// At least 1 number
	var validityRegex =  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,50}$/;
	if (!password.match(validityRegex)) {
		console.log(`Failed password validity check`);
		return false;
	}
	
	return true;
};

export const accessGuard = (accessLevels) => {
	let granted = false;
	for (let i in accessLevels) {
		const accessLevel = accessLevels[i];
		if (userService.AccessLevel() === accessLevel) {
			granted = true;
			break;
		}
	}
	return granted;
}

export const getServerURL = () => {
	if (window.location.href.indexOf("127.0.0.1") !== -1) {
		return "http://127.0.0.1:9020";
	}
	
	return "https://cymplify-app.com:8080";
};

export const getMonthsBetweenDates = (fromDate, toDate) => {
	let diff = (fromDate.getTime() - toDate.getTime()) / 1000;
	diff /= (60 * 60 * 24 * 7 * 4);
	return Math.abs(Math.ceil(diff));
};

export const fileToBase64 = (file) => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		
		reader.onload = (e) => {
			resolve(e.target.result);
		};
		reader.onerror = (err) => {
			reject(err);
		};
		
		reader.readAsDataURL(file);
	});
};

export const truncateSentence = (sentence, len) => {
	let newSentence = sentence.substring(0, len);
	let parts = newSentence.split(" ");
	parts.pop();
	newSentence = parts.join(" ");
	return newSentence;
};

export const truncateString = (string, len) => {
	if (string.length <= len) return string;
	
	let newString = string.substring(0, len);
	newString += "...";
	return newString;
};
